"use client";

import { useCallback, useEffect, useState } from "react";
import Container from "@/components/atom/Container";
import Crumbs from "@/components/atom/Crumbs";
import {
  addCarts,
  getCarts,
  getFeeAdmin,
  getVouchers
} from "@/functions/databaseData";
import Table from "./_component/Table";
import Rincian from "./_component/Rincian";
import { cn } from "@/utils/twMerge";
import { usePathname } from "next/navigation";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import useHeader from "@/functions/useHeader";

export default function Cart() {
  const path = usePathname();
  const queryClient = useQueryClient();
  const { session, status, carts } = useHeader();
  const [calculateStock, setCalculateStock] = useState({});

  useEffect(() => {
    if (
      (!carts?.biaya_pengiriman || carts?.biaya_pengiriman <= 0) &&
      (!carts?.fee_admin || carts?.fee_admin <= 0)
    )
      return;
    runChooseKurir();
  }, []);

  const runChooseKurir = useCallback(async () => {
    try {
      const biaya_pengiriman = carts?.biaya_pengiriman ?? 0;
      const fee_admin = carts?.fee_admin ?? 0;
      const total_pembayaran =
        carts?.total_pembayaran - biaya_pengiriman - fee_admin;

      let data = {
        id: session?.user?.data?.cart_id,
        fee_admin: 0,
        total_pembayaran,
        change: "reset"
      };
      const res = await addCarts({ body: data });
      queryClient.setQueryData(["carts"], old => res);
      setCalculateStock({});
    } catch (error) {
      console.log(error.message);
    }
  }, [carts?.biaya_pengiriman, carts?.fee_admin]);

  const overStock = Object.entries(calculateStock ?? {})
    ?.map(([_, item]) => item)
    .filter((item) => item == true)?.length;

  return (
    <div className={cn("z-10", "mt-32")}>
      <Container showMQ={false} className={"min-h-screen"}>
        <div className="flex flex-col container-mini w-full">
          <Crumbs />

          <div className="flex flex-col gap-4">
            {!carts && status == "loading" ? (
              // <Loading className={"h-screen md:h-[50vh]"} />
              <>
                <div className="w-full h-[200px] animate-pulse bg-greyscaleGON-200" />
                <div className="w-full h-[80px] animate-pulse bg-greyscaleGON-200" />
              </>
            ) : (
              <>
                <Table
                  datas={Object.entries(carts?.products ?? {})}
                  carts={carts}
                  calculateStock={calculateStock}
                  setCalculateStock={setCalculateStock}
                  session={session}
                />
                <Rincian
                  datas={Object.entries(carts?.products ?? {})}
                  carts={carts}
                  overStock={overStock}
                  session={session}
                />
              </>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
}
